// extracted by mini-css-extract-plugin
export default {"formItem":"Error_formItem__sJn-9","input":"Error_input__KTWAy","inputError":"Error_inputError__9oHa+","errorMessage":"Error_errorMessage__zkd7+"};